
export const DATA_CHART_MAIN = {
        xaxis: {
            categories: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio', 'Agosto','Septiembre','Octubre','Noviembre','Diciembre']
        },
        plotOptions: {
            bar: {
            horizontal: true
            }
        },
        dataLabels: {
            enabled: false
        },
        responsive: [
            {
            breakpoint: 500,
            options: {
                plotOptions: {
                    bar: {
                        horizontal: false
                    }
                },
                legend: {
                    position: "bottom"
                    }
                }
            }
        ],
        colors: ['#1e3a8a']
    }


export const HOVER_CLASS = 'text-gray-400 hover:bg-gray-800 hover:text-white group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold';
export const BUTTON_LINE_ICON = 'inline-flex items-center gap-x-1.5 rounded-md bg-indigo-900 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-900'


export const personas = [
  {
    nombre: 'Juan Pérez',
    identificacion: '123456789',
    correo: 'juan.perez@example.com',
    telefono: '555-123-4567',
    rol: 'Administrador'
  },
  {
    nombre: 'María Rodríguez',
    identificacion: '987654321',
    correo: 'maria.123123@example.com',
    telefono: '555-567-8910',
    rol: 'Consultor'
  },
  {
    nombre: 'María Perez',
    identificacion: '987654321',
    correo: 'maria.asdaa@example.com',
    telefono: '555-567-8910',
    rol: 'Analista'
  },
  {
    nombre: 'María Bolaños',
    identificacion: '987654321',
    correo: 'maria.123213@example.com',
    telefono: '555-567-8910',
    rol: 'Analista'
  },
  {
    nombre: 'Santiago Rodríguez',
    identificacion: '987654321',
    correo: 'maria.asdada@example.com',
    telefono: '555-567-8910',
    rol: 'Analista'
  },
];

export const DROPDOWN_USER_ITEMS = [
    {
        value:'Detalles',
        path:'/users/details',
        type:'details',
    },
    {
        value:'Administrar Roles',
        path:'/users/details',
        type:'rules',
    },
    {
        value:'Historial',
        path:'/users/details',
        type:'history',
    },
    {
        value:'Administrar datos',
        path:'/users/details',
        type:'update',
    },
]


export const PENALITIES = [
  {
    nombre: 'Juan Pérez',
    documento: '123456789',
    vehiculo: 'Chevrolet',
    placa: 'ABC123',
    condicion: 'Conductor designado',
    fecha: '2023-11-22',
    tipo: 'Multa',
    costo: 50000,
    status: 'payed'
  },
  {
    nombre: 'María López',
    documento: '987654321',
    vehiculo: 'Toyota',
    placa: 'XYZ456',
    condicion: 'Prestado',
    fecha: '2023-12-05',
    tipo: 'Alerta',
    costo: 0,
    status: 'pending'
  },
  // Agrega más elementos aquí...
  {
    nombre: 'Pedro Gómez',
    documento: '456789123',
    vehiculo: 'Honda',
    placa: 'DEF789',
    condicion: 'Propietario',
    fecha: '2024-01-15',
    tipo: 'Alerta',
    costo: 0,
    status: 'payed'
  }
];

//export const BASE_API = 'http://89.117.75.243:2793/';
export const BASE_API = process.env.REACT_APP_BASE_API_URL;
// export const BASE_API = 'https://lightsoftwareqa.com/polichacao/'; ///agregar env
export const BASE_TOKEN = 'R3pKSTV4UkFTdjhKZHQvOFlEVzNOSmViSmpyZHNFTUIxSzZRN0hjPQ==';
//update


export const STEP_ONE = {
        identification:'',
        firstName:'',
        secondName:'',
        firstLastName:'',
        secondLastName:'',
        gender:'M',
        email:'',
        direction:'',
        phone:'',
    }

export const STEP_TWO = {
        condition:'',
        plate:'',
        brand:'',
        model:'',
        color:'',
        year:'',
        serial:'',
        idParking:0,
        typeVehicle:0,
    }

export const STEP_TRHEE = {
        requiredCrane: false,
        craneList: [],
        crane:null,
        loadingCranes: true,
        idTowing:0,
    }

export const STEP_FOUR = {
        penalities:[],
        place:'',
        cost:'',
        detail:'',
    }

export const STEP_FIVE = {
        place:'',
        cost:'',
        detail:'',
        mustCompare:false,
        ubication:'',
        date:'',
        sector:'',
        idSubType:0,
        spot:''
    }

// export const BASE_URL = process.env.NODE_ENV === 'development' ?  '/polichacao/admin' : '/polichacao/admin'
export const BASE_URL = (process.env.REACT_APP_BASE_URL && process.env.REACT_APP_BASE_URL !== 'undefined') ? process.env.REACT_APP_BASE_URL : ''